import Vue from 'vue';
import VueRouter from 'vue-router';

import Jt from 'common/util/jt';
import store from 'common/store';

import hwRouter from 'hw/router';

Vue.use(VueRouter);

const Jt_D = Jt.dom;

const router = new VueRouter({
    // mode: 'history',
    // base: '/wap-news-mi/',
    routes: [
        ...hwRouter
    ],
    scrollBehavior(to, from, savedPosition) {
        if(savedPosition) {
            return savedPosition;
        } else {
            const position = {};
            if(to.hash) {
                position.selector = to.hash;
            }
            if(to.matched.some(m => m.meta.scrollToTop)) {
                position.x = 0;
                position.y = 0;
            }
            return position;
        }
    }
});

router.afterEach(function(to, from) {
    if(from.matched && from.matched.length) {
        const matchedPath = from.matched[0].path;
        if(matchedPath !== '/image/:id') {
            store.commit('app:update:scrollPos', {key: from.path, value: Jt_D.getScrollPos().y});
        }
    }
    if (from.path !== '/') {
        _hmt.push(['_trackPageview', '/wap-news-mi/#' + to.path]);
    }
    // _hmt.push(['_trackEvent', '小米', '所有页面', '访问次数']);
});

export default router;





// WEBPACK FOOTER //
// ./src/common/router/index.js